export * from './testing/browser_util';
export * from './testing/browser_static';
export * from './testing/matchers';
export * from './testing/browser';
export * from './testing/dom_test_component_renderer';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
